import onClickOutside from 'react-onclickoutside';
import React from 'react';
import DropdownHeader from './DropdownHeader';

interface DropdownProps {
  heading: string;
  menu: JSX.Element;
  hoverDisabled?: boolean;
  className?: string;
  closeOnClickInside?: boolean;
}

interface DropdownState {
  isOpen: boolean;
  isHovering: boolean;
}

class Dropdown extends React.Component<DropdownProps, DropdownState> {
  constructor(props: DropdownProps) {
    super(props);
    this.state = {
      isOpen: false,
      isHovering: false,
    };
  }

  render() {
    const show = this.state.isOpen || this.state.isHovering;
    return (
      <div
        className={'dropdown ' + (this.props.className || '')}
        onMouseEnter={this._startHover}
        onMouseLeave={this._endHover}
        onClick={this._onClickInside}
      >
        <div className="header-wrapper" onClick={this._toggle}>
          {<DropdownHeader isOpen={show} title={this.props.heading} />}
        </div>
        {show && (
          <div className="menu-wrapper">
            <div className="arrow-container">
              <div className="arrow"></div>
            </div>
            <div className="menu">{this.props.menu}</div>
          </div>
        )}
      </div>
    );
  }

  handleClickOutside = () => {
    this.setState({ isOpen: false });
  };
  private _onClickInside = () => this.props.closeOnClickInside && this.state.isOpen && this.setState({ isOpen: false });
  private _toggle = () => this.setState({ isOpen: !this.state.isOpen });
  private _startHover = () => !this.props.hoverDisabled && this.setState({ isHovering: true });
  private _endHover = () => this.setState({ isHovering: false });
}

export default onClickOutside(Dropdown);
